import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
    selector: 'app-venue-storefront-booking-payment-placeholder',
    standalone: true,
    templateUrl: './venue-storefront-booking-payment-placeholder.component.html',
    styleUrls: ['./venue-storefront-booking-payment-placeholder.component.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VenueStorefrontBookingPaymentPlaceholderComponent {}
